(function () {
  "use strict";

  // Guard Data
  var DATA = window.__CCW_GARAGE__ || {};
  var CONFIG = (DATA && DATA.config) ? DATA.config : { storagePrefix: "ccw_garage_" };
  var PREFIX = CONFIG.storagePrefix || "ccw_garage_";
  var ENTRIES = Array.isArray(DATA.entries) ? DATA.entries : [];
  var TRIM_ORDER = Array.isArray(DATA.TRIM_ORDER) ? DATA.TRIM_ORDER : [];

  // Storage Keys
  var KEYS = {
    year: PREFIX + "year",
    make: PREFIX + "make",
    trim: PREFIX + "trim_label",
    routeUrl: PREFIX + "route_url",
    mapHandle: PREFIX + "map_handle",
    featuredBundleHandle: PREFIX + "featured_bundle_handle",
    hubCollectionUrl: PREFIX + "hub_collection_url"
  };

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, val) {
    try { localStorage.setItem(key, String(val)); } catch (e) {}
  }
  function safeRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function getGarage() {
    return {
      year: safeGet(KEYS.year),
      make: safeGet(KEYS.make),
      trim: safeGet(KEYS.trim),
      routeUrl: safeGet(KEYS.routeUrl),
      mapHandle: safeGet(KEYS.mapHandle),
      featuredBundleHandle: safeGet(KEYS.featuredBundleHandle),
      hubCollectionUrl: safeGet(KEYS.hubCollectionUrl)
    };
  }

  function setGarage(payload) {
    if (!payload) return;
    if (payload.year != null) safeSet(KEYS.year, payload.year);
    if (payload.make != null) safeSet(KEYS.make, payload.make);
    if (payload.trim != null) safeSet(KEYS.trim, payload.trim);
    if (payload.routeUrl != null) safeSet(KEYS.routeUrl, payload.routeUrl);
    if (payload.mapHandle != null) safeSet(KEYS.mapHandle, payload.mapHandle);
    if (payload.featuredBundleHandle != null) safeSet(KEYS.featuredBundleHandle, payload.featuredBundleHandle);
    if (payload.hubCollectionUrl != null) safeSet(KEYS.hubCollectionUrl, payload.hubCollectionUrl);

    window.dispatchEvent(new CustomEvent("ccw:garage_changed", { detail: getGarage() }));
  }

  function clearGarage() {
    safeRemove(KEYS.year);
    safeRemove(KEYS.make);
    safeRemove(KEYS.trim);
    safeRemove(KEYS.routeUrl);
    safeRemove(KEYS.mapHandle);
    safeRemove(KEYS.featuredBundleHandle);
    safeRemove(KEYS.hubCollectionUrl);

    window.dispatchEvent(new CustomEvent("ccw:garage_changed", { detail: getGarage() }));
  }

  // Sorting trims: sort_order on the fitment metaobjects wins (admin-editable, lower shows
  // first within a make; labels within one entry keep their list order). TRIM_ORDER remains
  // as a legacy fallback for any entry without a sort_order value.
  var TRIM_RANK = new Map(TRIM_ORDER.map(function (t, i) { return [t, 90000 + i]; }));
  ENTRIES.forEach(function (e) {
    if (!e || e.sort_order == null || !Array.isArray(e.trims)) return;
    e.trims.forEach(function (t, i) {
      var v = Number(e.sort_order) + i * 0.1;
      if (!TRIM_RANK.has(t) || v < TRIM_RANK.get(t)) TRIM_RANK.set(t, v);
    });
  });

  function sortTrims(trims) {
    var uniq = Array.from(new Set(trims || []));
    uniq.sort(function (a, b) {
      var ra = TRIM_RANK.has(a) ? TRIM_RANK.get(a) : 999999;
      var rb = TRIM_RANK.has(b) ? TRIM_RANK.get(b) : 999999;
      if (ra !== rb) return ra - rb;
      return String(a).localeCompare(String(b));
    });
    return uniq;
  }

  // Legacy trim labels: saved garages store exact label strings, so renamed labels
  // must keep matching. Maps an old stored label to its replacement candidates; the
  // saved year narrows multi-candidate cases (e.g. HD5 vs HD7) to the right entry.
  var LEGACY_TRIMS = {
    "Ranger XP 1000": ["Ranger XP 1000 (All Models)"],
    "Defender PRO HD10": ["Defender PRO"],
    "XD 1500 (Premium/Ultimate)": ["Ranger XD 1500 Premium", "Ranger XD 1500 Ultimate"],
    "XD 1500 (Mountaineer)": ["Ranger XD 1500 Mountaineer"],
    "Defender HD5/HD7": ["Defender HD5", "Defender HD7"],
    "Defender HD8/HD9": ["Defender HD8", "Defender HD9"]
  };

  // 2027 Defender HD10 generation check: both generations exist in 2027 with different
  // kits, so these picks need explicit confirmation before routing.
  var GEN_GATE_TRIMS = {
    "Defender HD10 Gen 1": ["Gen 1", "Gen 2"],
    "Defender HD10 Gen 2": ["Gen 2", "Gen 1"]
  };

  function removeGenGate(root) {
    var g = root.querySelector("[data-ccw-gen-gate]");
    if (g && g.parentNode) g.parentNode.removeChild(g);
  }

  function genGateConfirmed(root) {
    var c = root.querySelector("[data-ccw-gen-gate] input");
    return !!(c && c.checked);
  }

  function showGenGate(root, submitEl, trim) {
    if (root.querySelector("[data-ccw-gen-gate]")) return;
    var gens = GEN_GATE_TRIMS[trim];
    var wrap = document.createElement("div");
    wrap.setAttribute("data-ccw-gen-gate", "");
    wrap.style.cssText = "margin-top:10px;padding:12px 14px;border:2px solid #df9935;border-radius:6px;background:rgba(223,153,53,.08);font-size:14px;line-height:1.45;text-align:left;";
    var msg = document.createElement("div");
    msg.innerHTML = "2027 Defender HD10s come in two generations with different kits. Gen 1 has the signature light <strong>below</strong> the headlights. Gen 2 has a redesigned front end with signature lights <strong>above</strong> them.";
    wrap.appendChild(msg);
    var label = document.createElement("label");
    label.style.cssText = "display:flex;gap:8px;align-items:flex-start;margin-top:10px;font-weight:600;cursor:pointer;";
    var box = document.createElement("input");
    box.type = "checkbox";
    box.style.cssText = "margin-top:2px;";
    var span = document.createElement("span");
    span.textContent = "I verified my Defender is a " + gens[0] + ", not a " + gens[1];
    label.appendChild(box);
    label.appendChild(span);
    wrap.appendChild(label);

    var imgs = (CONFIG.genGateImages || []);
    if (imgs.length === 2) {
      var toggle = document.createElement("button");
      toggle.type = "button";
      toggle.textContent = "See the difference";
      toggle.style.cssText = "margin-top:10px;background:none;border:none;padding:0;color:#1a699c;font-weight:600;font-size:13px;text-decoration:underline;cursor:pointer;display:block;";
      var pics = document.createElement("div");
      pics.style.cssText = "display:none;margin-top:10px;gap:10px;grid-template-columns:1fr 1fr;";
      [["Gen 1: signature light below the headlights", imgs[0]], ["Gen 2: signature lights above the headlights", imgs[1]]].forEach(function (pair) {
        var fig = document.createElement("figure");
        fig.style.cssText = "margin:0;";
        var img = document.createElement("img");
        img.setAttribute("data-src", pair[1]);
        img.alt = pair[0];
        img.style.cssText = "width:100%;height:auto;border-radius:4px;display:block;";
        var cap = document.createElement("figcaption");
        cap.textContent = pair[0];
        cap.style.cssText = "font-size:12px;margin-top:4px;opacity:.8;";
        fig.appendChild(img);
        fig.appendChild(cap);
        pics.appendChild(fig);
      });
      toggle.addEventListener("click", function () {
        var open = pics.style.display === "none";
        if (open) {
          pics.querySelectorAll("img").forEach(function (im) {
            if (!im.getAttribute("src")) im.setAttribute("src", im.getAttribute("data-src"));
          });
        }
        pics.style.display = open ? "grid" : "none";
        toggle.textContent = open ? "Hide the comparison" : "See the difference";
      });
      wrap.appendChild(toggle);
      wrap.appendChild(pics);
    }

    submitEl.insertAdjacentElement("afterend", wrap);
  }

  // Core matching
  function findMatchExact(year, make, trim) {
    year = Number(year);
    for (var i = 0; i < ENTRIES.length; i++) {
      var e = ENTRIES[i];
      if (!e) continue;
      if (year < Number(e.year_start) || year > Number(e.year_end)) continue;
      if (String(e.make) !== String(make)) continue;
      if (!Array.isArray(e.trims)) continue;
      if (e.trims.indexOf(trim) === -1) continue;
      return e;
    }
    return null;
  }

  function findMatch(year, make, trim) {
    var m = findMatchExact(year, make, trim);
    if (m) return m;
    var aliases = LEGACY_TRIMS[trim];
    if (!aliases) return null;
    for (var i = 0; i < aliases.length; i++) {
      m = findMatchExact(year, make, aliases[i]);
      if (m) return m;
    }
    return null;
  }

  function getRouteProductUrl(match) {
    if (!match) return null;
    return match.route_product_url || match.url || null;
  }

  function getRouteProductHandle(match) {
    if (!match) return null;
    return match.route_product_handle || null;
  }

  function getHubCollectionUrl(match) {
    if (!match) return null;
    return match.hub_collection_url || null;
  }

  function yearsFromEntries() {
    var set = new Set();
    ENTRIES.forEach(function (e) {
      if (!e) return;
      var ys = Number(e.year_start);
      var ye = Number(e.year_end);
      for (var y = ys; y <= ye; y++) set.add(y);
    });
    return Array.from(set).sort(function (a, b) { return b - a; });
  }

  function makesForYear(year) {
    var y = Number(year);
    var set = new Set();
    ENTRIES.forEach(function (e) {
      if (!e) return;
      if (y >= Number(e.year_start) && y <= Number(e.year_end)) set.add(e.make);
    });
    return Array.from(set).sort();
  }

  function trimsForYearMake(year, make) {
    var y = Number(year);
    var set = new Set();
    ENTRIES.forEach(function (e) {
      if (!e) return;
      if (y < Number(e.year_start) || y > Number(e.year_end)) return;
      if (String(e.make) !== String(make)) return;
      if (!Array.isArray(e.trims)) return;
      e.trims.forEach(function (t) { set.add(t); });
    });
    return sortTrims(Array.from(set));
  }

  // Widget mounting
  function mountFinders() {
    var nodes = document.querySelectorAll("[data-ccw-vehicle-finder]");
    if (!nodes.length) return;

    nodes.forEach(function (root) {
      var yearEl = root.querySelector("[data-ccw-year]");
      var makeEl = root.querySelector("[data-ccw-make]");
      var trimEl = root.querySelector("[data-ccw-trim]");
      var submitEl = root.querySelector("[data-ccw-submit]");
      var clearEl = root.querySelector("[data-ccw-clear]");
      var msgEl = root.querySelector("[data-ccw-msg]");

      if (!yearEl || !makeEl || !trimEl || !submitEl) return;
      if (root.getAttribute("data-ccw-mounted") === "true") return;
      root.setAttribute("data-ccw-mounted", "true");

      function setMsg(txt) { if (msgEl) msgEl.textContent = txt || ""; }
      function updateClearVisibility() {
        if (!clearEl) return;
        var hasSelection = Boolean(yearEl.value || makeEl.value || trimEl.value);
        clearEl.hidden = !hasSelection;
        clearEl.setAttribute("aria-hidden", String(!hasSelection));
      }
      function hasOption(selectEl, value) {
        if (!selectEl || value == null) return false;
        var target = String(value);
        for (var i = 0; i < selectEl.options.length; i++) {
          if (String(selectEl.options[i].value) === target) return true;
        }
        return false;
      }

      function resetAfterYear() {
        makeEl.innerHTML = '<option value="">Select make</option>';
        trimEl.innerHTML = '<option value="">Select model</option>';
        makeEl.disabled = true;
        trimEl.disabled = true;
        submitEl.disabled = true;
      }

      function resetAfterMake() {
        trimEl.innerHTML = '<option value="">Select model</option>';
        trimEl.disabled = true;
        submitEl.disabled = true;
      }

      function hydrateFromGarage() {
        var g = getGarage();
        if (!g.year || !g.make || !g.trim) return;

        // Restore Year
        if (!hasOption(yearEl, g.year)) return;
        yearEl.value = String(g.year);

        // Restore Make
        resetAfterYear();
        makesForYear(g.year).forEach(function (m) {
          var makeOpt = document.createElement("option");
          makeOpt.value = m;
          makeOpt.textContent = m;
          makeEl.appendChild(makeOpt);
        });
        makeEl.disabled = false;
        if (!hasOption(makeEl, g.make)) return;
        makeEl.value = String(g.make);

        // Restore Trim
        resetAfterMake();
        trimsForYearMake(g.year, g.make).forEach(function (t) {
          var trimOpt = document.createElement("option");
          trimOpt.value = t;
          trimOpt.textContent = t;
          trimEl.appendChild(trimOpt);
        });
        trimEl.disabled = false;
        if (!hasOption(trimEl, g.trim)) return;
        trimEl.value = String(g.trim);
        submitEl.disabled = false;
        updateClearVisibility();
      }

      // populate years
      var years = yearsFromEntries();
      years.forEach(function (y) {
        var opt = document.createElement("option");
        opt.value = String(y);
        opt.textContent = String(y);
        yearEl.appendChild(opt);
      });

      yearEl.addEventListener("change", function () {
        resetAfterYear();
        setMsg("");
        var y = yearEl.value;
        if (!y) {
          updateClearVisibility();
          return;
        }

        makesForYear(y).forEach(function (m) {
          var opt = document.createElement("option");
          opt.value = m;
          opt.textContent = m;
          makeEl.appendChild(opt);
        });
        makeEl.disabled = false;
        updateClearVisibility();
      });

      makeEl.addEventListener("change", function () {
        resetAfterMake();
        setMsg("");
        var y = yearEl.value;
        var m = makeEl.value;
        if (!y || !m) {
          updateClearVisibility();
          return;
        }

        trimsForYearMake(y, m).forEach(function (t) {
          var opt = document.createElement("option");
          opt.value = t;
          opt.textContent = t;
          trimEl.appendChild(opt);
        });
        trimEl.disabled = false;
        updateClearVisibility();
      });

      trimEl.addEventListener("change", function () {
        submitEl.disabled = !trimEl.value;
        removeGenGate(root);
        updateClearVisibility();
      });

      submitEl.addEventListener("click", function () {
        setMsg("");
        var y = yearEl.value;
        var m = makeEl.value;
        var t = trimEl.value;
        if (!y || !m || !t) return;

        if (GEN_GATE_TRIMS[t] && !genGateConfirmed(root)) {
          showGenGate(root, submitEl, t);
          setMsg("Please confirm your Defender generation.");
          return;
        }

        var match = findMatch(y, m, t);
        if (!match) { setMsg("No match found."); return; }

        var routeProductUrl = getRouteProductUrl(match);
        var hubCollectionUrl = getHubCollectionUrl(match);
        var redirectUrl = hubCollectionUrl || routeProductUrl;
        if (!redirectUrl) { setMsg("No route found."); return; }

        setGarage({
          year: y,
          make: m,
          trim: t,
          routeUrl: routeProductUrl || redirectUrl,
          hubCollectionUrl: hubCollectionUrl,
          featuredBundleHandle: getRouteProductHandle(match),
          mapHandle: match.handle
        });

        // Inline finders (plate bracket page) resolve on the page instead of redirecting.
        if (root.hasAttribute("data-ccw-finder-inline")) {
          root.dispatchEvent(new CustomEvent("ccw:finder_match", {
            bubbles: true,
            detail: { match: match, year: y, make: m, trim: t }
          }));
          return;
        }

        window.location.href = redirectUrl;
      });

      if (clearEl) {
        clearEl.addEventListener("click", function () {
          clearGarage();
          yearEl.value = "";
          resetAfterYear();
          setMsg("Cleared.");
          updateClearVisibility();
        });
      }

      // initialize state label
      resetAfterYear();
      hydrateFromGarage();
      updateClearVisibility();
    });
  }

  function mountLabels() {
    var nodes = document.querySelectorAll("[data-ccw-garage-label]");
    var helperNodes = document.querySelectorAll("[data-ccw-garage-helper]");
    if (!nodes.length && !helperNodes.length) return;
    var shells = document.querySelectorAll("[data-ccw-garage-label-shell]");
    var MAX_LABEL_CHARS = 27;

    function truncateLabel(text, maxChars) {
      if (!text || text.length <= maxChars) return text;
      return text.slice(0, maxChars - 1).trimEnd() + "…";
    }

    function getHelperText(baseText, hasVehicle) {
      var txt = String(baseText || "");
      if (!hasVehicle) return txt;
      var selectedTxt = txt.replace(/\bfind\b/i, "Showing").trim();
      if (!/\byour\b$/i.test(selectedTxt)) {
        selectedTxt += " your";
      }
      return selectedTxt;
    }

    function closeAllPanels() {
      shells.forEach(function (shell) {
        var panel = shell.querySelector("[data-ccw-garage-label-panel]");
        var toggle = shell.querySelector("[data-ccw-garage-label-toggle]");
        if (panel) panel.hidden = true;
        if (toggle) toggle.setAttribute("aria-expanded", "false");
      });
    }

    function render() {
      var g = getGarage();
      var hasVehicle = Boolean(g.year && g.make && g.trim);
      var fullText = hasVehicle
        ? (g.year + " " + g.make + " " + g.trim)
        : "Enter Your Vehicle";
      var txt = hasVehicle ? truncateLabel(fullText, MAX_LABEL_CHARS) : fullText;

      nodes.forEach(function (el) {
        el.textContent = txt;
        if (hasVehicle) {
          el.setAttribute("title", fullText);
        } else {
          el.removeAttribute("title");
        }
      });
      shells.forEach(function (shell) {
        shell.classList.toggle("ccw-garage-label-shell--has-vehicle", hasVehicle);
      });
      helperNodes.forEach(function (el) {
        var baseText = el.getAttribute("data-ccw-garage-helper-default");
        if (!baseText) baseText = el.textContent || "";
        el.textContent = getHelperText(baseText, hasVehicle);
      });
    }

    shells.forEach(function (shell) {
      var panel = shell.querySelector("[data-ccw-garage-label-panel]");
      var toggle = shell.querySelector("[data-ccw-garage-label-toggle]");
      if (!panel || !toggle) return;

      toggle.addEventListener("click", function (evt) {
        evt.stopPropagation();
        var isHidden = panel.hidden;
        closeAllPanels();
        if (isHidden) {
          panel.hidden = false;
          toggle.setAttribute("aria-expanded", "true");
        }
      });

      panel.addEventListener("click", function (evt) {
        evt.stopPropagation();
      });
    });

    document.addEventListener("click", closeAllPanels);
    document.addEventListener("keydown", function (evt) {
      if (evt.key === "Escape") closeAllPanels();
    });

    render();
    window.addEventListener("ccw:garage_changed", render);
    window.addEventListener("ccw:garage_changed", closeAllPanels);
  }

  function mountFitmentMessages() {
    var nodes = document.querySelectorAll("[data-ccw-fitment]");
    if (!nodes.length) return;

    function normalizePath(url) {
      if (!url) return "/";
      try {
        var parsed = new URL(url, window.location.origin);
        var path = parsed.pathname || "/";
        return (path.length > 1) ? path.replace(/\/+$/, "") : "/";
      } catch (e) {
        var basic = String(url).split("?")[0].split("#")[0] || "/";
        return (basic.length > 1) ? basic.replace(/\/+$/, "") : "/";
      }
    }

    function isSameProductUrl(a, b) {
      return normalizePath(a) === normalizePath(b);
    }

    function setFitment(el, state, icon, message, linkUrl, linkText, openModalId) {
      el.classList.remove("ccw-fitment--neutral", "ccw-fitment--fit", "ccw-fitment--mismatch", "ccw-fitment--unknown");
      el.classList.add("ccw-fitment--" + state);
      var staticNodes = Array.from(el.querySelectorAll("[data-ccw-fitment-static]"));
      el.innerHTML = "";

      if (icon) {
        var iconEl = document.createElement("span");
        iconEl.className = "ccw-fitment-icon";
        iconEl.textContent = icon;
        el.appendChild(iconEl);
      }

      var bodyEl = document.createElement("span");
      bodyEl.className = "ccw-fitment-body";
      var hasLink = Boolean(linkText && (linkUrl || openModalId));
      var linkEl = null;
      if (hasLink) {
        linkEl = document.createElement("a");
        linkEl.href = linkUrl || "#";
        linkEl.textContent = linkText;
        if (openModalId) {
          linkEl.setAttribute("data-ccw-vehicle-modal-open", openModalId);
        }
      }

      if (hasLink && message && message.indexOf("{{link}}") !== -1) {
        var parts = message.split("{{link}}");
        bodyEl.appendChild(document.createTextNode(parts[0]));
        bodyEl.appendChild(linkEl);
        bodyEl.appendChild(document.createTextNode(parts.slice(1).join("{{link}}")));
      } else {
        bodyEl.appendChild(document.createTextNode(message || ""));
        if (hasLink) {
          bodyEl.appendChild(document.createTextNode(" "));
          bodyEl.appendChild(linkEl);
        }
      }

      el.appendChild(bodyEl);
      staticNodes.forEach(function (node) {
        el.appendChild(node);
      });
    }

    function render() {
      var g = getGarage();
      nodes.forEach(function (el) {
        if (!g.year || !g.make || !g.trim) {
          var vehicleModalId = el.getAttribute("data-ccw-vehicle-modal-id");
          setFitment(el, "neutral", "", "{{link}} to confirm fitment.", null, "Select your vehicle", vehicleModalId);
          return;
        }

        var vehicleText = g.year + " " + g.make + " " + g.trim;
        var match = findMatch(g.year, g.make, g.trim);
        var routeProductUrl = getRouteProductUrl(match);
        if (!match || !routeProductUrl) {
          setFitment(el, "unknown", "!", "We couldn't verify fitment for your " + vehicleText + ".");
          return;
        }

        var currentProductUrl = el.getAttribute("data-ccw-current-product-url") || window.location.pathname;
        if (isSameProductUrl(currentProductUrl, routeProductUrl)) {
          setFitment(el, "fit", "✓", "Fits your " + vehicleText + ".");
          return;
        }

        setFitment(
          el,
          "mismatch",
          "✕",
          "Does not fit your " + vehicleText + ".",
          routeProductUrl,
          "View the correct product."
        );
      });
    }

    render();
    window.addEventListener("ccw:garage_changed", render);
  }

  function mountSelectVehicleHashTrigger() {
    if (window.__CCW_SELECT_VEHICLE_HASH_BOUND__) return;
    window.__CCW_SELECT_VEHICLE_HASH_BOUND__ = true;

    function openVehicleModal() {
      var modal = document.querySelector("[data-ccw-vehicle-modal]");
      if (!modal) return false;

      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      if (modal.__ccwCloseTimer) {
        clearTimeout(modal.__ccwCloseTimer);
      }

      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add("is-open");
      });
      return true;
    }

    function handleHashOpen() {
      if (window.location.hash !== "#select-vehicle") return;
      openVehicleModal();
    }

    document.addEventListener("click", function (event) {
      var hashLink = event.target.closest('a[href="#select-vehicle"]');
      if (!hashLink) return;

      event.preventDefault();
      if (window.location.hash !== "#select-vehicle") {
        window.location.hash = "select-vehicle";
      } else {
        openVehicleModal();
      }
    });

    window.addEventListener("hashchange", handleHashOpen);
    handleHashOpen();
  }

  function mountHubFeaturedBundles() {
    var slots = document.querySelectorAll("[data-ccw-featured-bundle]");
    if (!slots.length) return;

    function appendTemplateWithVehicle(target, template, vehicleText) {
      var parts = String(template || "").split("{vehicle}");
      if (parts.length === 1) {
        target.textContent = parts[0];
        return;
      }

      for (var i = 0; i < parts.length; i++) {
        if (parts[i]) {
          target.appendChild(document.createTextNode(parts[i]));
        }
        if (i < parts.length - 1) {
          var strong = document.createElement("strong");
          strong.textContent = vehicleText || "";
          target.appendChild(strong);
        }
      }
    }

    function setFinderVisibility(slot, shouldShow) {
      var root = slot.closest("[data-ccw-hub-featured-root]") || slot.parentElement;
      if (!root) return;
      var finder = root.querySelector("[data-ccw-hub-finder]");
      if (!finder) return;
      finder.hidden = !shouldShow;
    }

    function normalizeHandle(handle) {
      return String(handle || "").trim().toLowerCase();
    }

    function templateText(template, vehicleText) {
      return String(template || "").replace("{vehicle}", vehicleText || "");
    }

    function handleFromHref(href) {
      var raw = String(href || "");
      var match = raw.match(/\/products\/([^/?#]+)/i);
      return match ? normalizeHandle(match[1]) : "";
    }

    function isInsideAnySlot(node) {
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].contains(node)) return true;
      }
      return false;
    }

    function resolveHideTarget(node) {
      if (!node) return null;
      return (
        node.closest("[data-ccw-grid-item]") ||
        node.closest(".m-product-item") ||
        node
      );
    }

    function resolveCardNode(node) {
      if (!node) return null;
      if (node.matches("[data-ccw-product-card], .m-product-card, .product-card")) return node;
      return (
        node.querySelector("[data-ccw-product-card]") ||
        node.querySelector(".m-product-card") ||
        node.querySelector(".product-card") ||
        node
      );
    }

    function getHandleFromNode(node) {
      if (!node) return "";
      var explicit = node.getAttribute("data-ccw-handle");
      if (explicit) return normalizeHandle(explicit);
      var card = resolveCardNode(node);
      if (card) {
        var nested = card.getAttribute("data-ccw-handle");
        if (nested) return normalizeHandle(nested);
      }
      var link = (card || node).querySelector("a[href*='/products/']");
      return handleFromHref(link ? link.getAttribute("href") : "");
    }

    function resolveCardRootFromAnchor(anchor) {
      return (
        anchor.closest("[data-ccw-product-card]") ||
        anchor.closest(".m-product-card") ||
        anchor.closest(".product-card") ||
        anchor.closest("[data-ccw-handle]") ||
        anchor.closest(".grid__item") ||
        anchor.closest("li") ||
        anchor.closest("article") ||
        anchor.closest(".card-wrapper") ||
        anchor
      );
    }

    function findCardByHandle(featuredHandle) {
      if (!featuredHandle) return null;

      var explicitCards = document.querySelectorAll("[data-ccw-handle]");
      for (var i = 0; i < explicitCards.length; i++) {
        var explicitCard = explicitCards[i];
        if (isInsideAnySlot(explicitCard)) continue;
        if (getHandleFromNode(explicitCard) !== featuredHandle) continue;
        return {
          cardEl: resolveCardNode(explicitCard),
          hideEl: resolveHideTarget(explicitCard)
        };
      }

      var anchors = document.querySelectorAll("a[href*='/products/']");
      for (var j = 0; j < anchors.length; j++) {
        var anchor = anchors[j];
        if (isInsideAnySlot(anchor)) continue;
        if (handleFromHref(anchor.getAttribute("href")) !== featuredHandle) continue;
        var candidate = resolveCardRootFromAnchor(anchor);
        if (isInsideAnySlot(candidate)) continue;
        return {
          cardEl: resolveCardNode(candidate),
          hideEl: resolveHideTarget(candidate)
        };
      }

      return null;
    }

    function findEntryByMapHandle(mapHandle) {
      var target = normalizeHandle(mapHandle);
      if (!target) return null;
      for (var i = 0; i < ENTRIES.length; i++) {
        var entry = ENTRIES[i];
        if (!entry) continue;
        if (normalizeHandle(entry.handle) === target) return entry;
      }
      return null;
    }

    function findEntryByRouteProductHandle(routeHandle) {
      var target = normalizeHandle(routeHandle);
      if (!target) return null;
      for (var i = 0; i < ENTRIES.length; i++) {
        var entry = ENTRIES[i];
        if (!entry) continue;
        if (normalizeHandle(entry.route_product_handle) === target) return entry;
      }
      return null;
    }

    function restoreHiddenCards() {
      var hidden = document.querySelectorAll("[data-ccw-featured-hidden='true'], [data-ccw-bundle-hidden='true']");
      hidden.forEach(function (card) {
        card.style.display = "";
        card.removeAttribute("data-ccw-featured-hidden");
        card.removeAttribute("data-ccw-bundle-hidden");
      });
    }

    function hideCard(node, markerAttr) {
      var target = resolveHideTarget(node);
      if (!target || isInsideAnySlot(target)) return;
      target.style.display = "none";
      target.setAttribute(markerAttr, "true");
    }

    function getMessageEl(slot) {
      var root = slot.closest("[data-ccw-hub-featured-root]") || slot.parentElement;
      if (!root) return null;
      return root.querySelector("[data-ccw-hub-message]");
    }

    function setHubMessage(slot, message) {
      var el = getMessageEl(slot);
      if (!el) return;
      el.textContent = message || "";
      el.hidden = !message;
    }

    function featuredTitle(slot, vehicleText) {
      var template = slot.getAttribute("data-ccw-featured-title") || "Recommended Bundle for your {vehicle}";
      return templateText(template, vehicleText);
    }

    function featuredEyebrow(slot, vehicleText) {
      var template = slot.getAttribute("data-ccw-featured-eyebrow") || "";
      return templateText(template, vehicleText).trim();
    }

    function featuredDescription(slot, vehicleText) {
      var template = slot.getAttribute("data-ccw-featured-description") || "";
      return templateText(template, vehicleText).trim();
    }

    function featuredCtaLabel(slot) {
      return (slot.getAttribute("data-ccw-featured-cta-label") || "View Bundle").trim();
    }

    function createCheckSvgIcon(className) {
      var icon = document.createElement("span");
      icon.className = className;
      icon.setAttribute("aria-hidden", "true");

      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("viewBox", "0 0 448 512");
      svg.setAttribute("focusable", "false");
      svg.setAttribute("aria-hidden", "true");

      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute(
        "d",
        "M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"
      );
      svg.appendChild(path);
      icon.appendChild(svg);
      return icon;
    }

    function appendMatchBanner(slot, vehicleText, featuredMeta) {
      var banner = document.createElement("section");
      banner.className = "ccw-hub-match-banner";

      var topRow = document.createElement("div");
      topRow.className = "ccw-hub-match-top";

      var kicker = document.createElement("span");
      kicker.className = "ccw-hub-match-kicker";
      kicker.appendChild(createCheckSvgIcon("ccw-hub-match-kicker-icon"));
      kicker.appendChild(document.createTextNode("Matched for your machine"));
      topRow.appendChild(kicker);

      var desc = document.createElement("p");
      desc.className = "ccw-hub-match-description";
      appendTemplateWithVehicle(
        desc,
        "Pre-configured for your {vehicle}",
        vehicleText
      );
      topRow.appendChild(desc);
      banner.appendChild(topRow);

      var bottomRow = document.createElement("div");
      bottomRow.className = "ccw-hub-match-bottom";

      var points = document.createElement("div");
      points.className = "ccw-hub-match-points";

      var pointLabels = [
        "Vehicle-Specific Match"
      ];

      pointLabels.forEach(function (label) {
        var point = document.createElement("span");
        point.className = "ccw-hub-match-point";
        point.appendChild(createCheckSvgIcon("ccw-hub-match-point-icon"));
        point.appendChild(document.createTextNode(label));
        points.appendChild(point);
      });

      bottomRow.appendChild(points);

      var clearButton = document.createElement("button");
      clearButton.type = "button";
      clearButton.className = "ccw-hub-match-reset";
      clearButton.textContent = "Clear vehicle";
      clearButton.addEventListener("click", function () {
        clearGarage();
      });
      bottomRow.appendChild(clearButton);

      banner.appendChild(bottomRow);

      slot.appendChild(banner);
    }

    function appendCorbinLinkRow(parent, featuredMeta) {
      if (!featuredMeta || !featuredMeta.corbinlink) return;
      var clRow = document.createElement("div");
      clRow.className = "ccw-hub-cl-row";
      var clLabel = document.createElement("span");
      clLabel.className = "ccw-hub-cl-row__label";
      clLabel.textContent = "Now available with CorbinLink\u2122 Wireless. The shortest install path we make.";
      clRow.appendChild(clLabel);
      parent.appendChild(clRow);
    }

    function featuredShowPrice(slot) {
      return (slot.getAttribute("data-ccw-featured-show-price") || "").toLowerCase() !== "false";
    }

    function hidePaginationWhenFiltered(slot) {
      return (slot.getAttribute("data-ccw-hide-pagination-when-filtered") || "true").toLowerCase() !== "false";
    }

    function setPaginationHidden(hidden) {
      var pagers = document.querySelectorAll(".m-collection--pagination");
      pagers.forEach(function (pager) {
        pager.style.display = hidden ? "none" : "";
      });
    }

    function slotMessage(slot, attrName, fallback) {
      var raw = slot.getAttribute(attrName);
      return raw ? String(raw).trim() : fallback;
    }

    function readCardMeta(cardEl) {
      var card = resolveCardNode(cardEl);
      if (!card) return null;

      var url = card.getAttribute("data-ccw-product-url");
      if (!url) {
        var linkEl = card.querySelector("a[href*='/products/']");
        url = linkEl ? linkEl.getAttribute("href") : "";
      }

      var title = card.getAttribute("data-ccw-product-title");
      if (!title) {
        var titleEl = card.querySelector(".m-product-card__name, .m-product-title, [data-product-title], h3, h2");
        title = titleEl ? titleEl.textContent : "";
      }

      var imageUrl = card.getAttribute("data-ccw-product-image");
      if (!imageUrl) {
        var imgEl = card.querySelector("img");
        imageUrl = imgEl ? (imgEl.getAttribute("src") || imgEl.getAttribute("data-src") || "") : "";
      }

      var price = card.getAttribute("data-ccw-product-price");
      if (!price) {
        var priceEl = card.querySelector(".m-price, .price, .price-item, [data-product-price]");
        price = priceEl ? priceEl.textContent : "";
      }

      var clWrap = card.closest("[data-ccw-corbinlink]");
      var hasCorbinLink =
        (clWrap && clWrap.getAttribute("data-ccw-corbinlink") === "true") ||
        (card.getAttribute && card.getAttribute("data-ccw-corbinlink") === "true") ||
        !!card.querySelector("[data-ccw-corbinlink='true']");

      return {
        corbinlink: hasCorbinLink,
        handle: getHandleFromNode(card),
        url: String(url || ""),
        title: String(title || "").trim(),
        imageUrl: String(imageUrl || ""),
        price: String(price || "").trim()
      };
    }

    function getDashIntegrationState(rawValue) {
      var raw = "";
      if (Array.isArray(rawValue)) {
        raw = rawValue.join(" ");
      } else {
        raw = rawValue == null ? "" : String(rawValue);
      }
      var normalized = raw.trim().toLowerCase();
      if (!normalized) return "compatible";
      if (normalized.indexOf("not compatible") > -1) return "not_compatible";
      if (normalized.indexOf("only compatible with select models") > -1) return "select_models";
      if (normalized.indexOf("compatible") > -1) return "compatible";
      return "compatible";
    }

    function appendProductTitleWithBundleBreak(target, rawTitle) {
      var suffix = "Turn Signal Kit Bundle";
      var normalizedTitle = String(rawTitle || "").replace(/\s+/g, " ").trim();
      if (!normalizedTitle) return;

      target.textContent = "";

      if (
        normalizedTitle.length > suffix.length &&
        normalizedTitle.slice(-suffix.length) === suffix
      ) {
        var prefix = normalizedTitle.slice(0, -suffix.length).trim();
        if (prefix) {
          target.appendChild(document.createTextNode(prefix));
        }

        var suffixEl = document.createElement("span");
        suffixEl.className = "ccw-hub-featured-product-title-break";
        suffixEl.textContent = suffix;
        target.appendChild(suffixEl);
        return;
      }

      target.textContent = normalizedTitle;
    }

    function appendFeaturedCard(slot, cardMeta, vehicleText, match) {
      var wrapper = document.createElement("article");
      wrapper.className = "ccw-hub-featured-card";

      var mediaLink = document.createElement("a");
      mediaLink.className = "ccw-hub-featured-media";
      mediaLink.href = cardMeta.url || "#";
      if (cardMeta.imageUrl) {
        var image = document.createElement("img");
        image.src = cardMeta.imageUrl;
        image.alt = cardMeta.title || featuredTitle(slot, vehicleText);
        mediaLink.appendChild(image);
      }
      wrapper.appendChild(mediaLink);

      var content = document.createElement("div");
      content.className = "ccw-hub-featured-content";

      var details = document.createElement("div");
      details.className = "ccw-hub-featured-details";

      var eyebrowTemplate = slot.getAttribute("data-ccw-featured-eyebrow") || "";
      if (eyebrowTemplate.trim()) {
        var eyebrowEl = document.createElement("div");
        eyebrowEl.className = "ccw-hub-featured-eyebrow";
        appendTemplateWithVehicle(eyebrowEl, eyebrowTemplate, vehicleText);
        details.appendChild(eyebrowEl);
      }

      var productTitle = document.createElement(cardMeta.url ? "a" : "h3");
      productTitle.className = "ccw-hub-featured-product-title";
      if (cardMeta.url) productTitle.href = cardMeta.url;
      if (cardMeta.title) {
        appendProductTitleWithBundleBreak(productTitle, cardMeta.title);
      } else {
        var featuredTitleTemplate = slot.getAttribute("data-ccw-featured-title") || "Recommended Bundle for your {vehicle}";
        appendTemplateWithVehicle(productTitle, featuredTitleTemplate, vehicleText);
      }
      details.appendChild(productTitle);

      var descriptionTemplate = slot.getAttribute("data-ccw-featured-description") || "";
      if (descriptionTemplate.trim()) {
        var descEl = document.createElement("div");
        descEl.className = "ccw-hub-featured-description";
        appendTemplateWithVehicle(descEl, descriptionTemplate, vehicleText);
        details.appendChild(descEl);
      }

      appendCorbinLinkRow(details, cardMeta);

      var includes = document.createElement("ul");
      includes.className = "ccw-hub-featured-includes";
      var includeLabels = [
        "Front LED Turn Signal Indicators",
        "Plug & Play Wiring Harness",
        "Hazard Functionality",
        "Carling Rocker Switches",
        "Horn Kit"
      ];
      var dashState = getDashIntegrationState(match && match.dash_light_integration);
      if (dashState !== "not_compatible") {
        includeLabels.splice(4, 0, dashState === "select_models" ? "Dash Light Integration*" : "Dash Light Integration");
      }
      includeLabels.forEach(function (itemLabel) {
        var item = document.createElement("li");
        item.appendChild(createCheckSvgIcon("ccw-hub-featured-include-icon"));
        item.appendChild(document.createTextNode(itemLabel));
        includes.appendChild(item);
      });
      details.appendChild(includes);
      content.appendChild(details);

      var footer = document.createElement("div");
      footer.className = "ccw-hub-featured-footer";

      if (featuredShowPrice(slot) && cardMeta.price) {
        var priceEl = document.createElement("div");
        priceEl.className = "ccw-hub-featured-price";
        var priceText = String(cardMeta.price || "").replace(/\s+/g, " ").trim();
        var pricePrefix = "From";
        var amountText = priceText;

        if (/^from\b/i.test(priceText)) {
          pricePrefix = priceText.match(/^from\b/i)[0];
          amountText = priceText.replace(/^from\b\s*/i, "");
        }

        var fromEl = document.createElement("div");
        fromEl.className = "ccw-hub-featured-price-prefix";
        fromEl.textContent = pricePrefix;
        priceEl.appendChild(fromEl);

        var amountEl = document.createElement("div");
        amountEl.className = "ccw-hub-featured-price-amount";
        amountEl.textContent = amountText || priceText;
        priceEl.appendChild(amountEl);

        footer.appendChild(priceEl);
      } else {
        footer.classList.add("is-no-price");
      }

      var actions = document.createElement("div");
      actions.className = "ccw-hub-featured-actions";
      var button = document.createElement("a");
      button.className = "m-button m-button--primary";
      button.href = cardMeta.url || "#";
      button.textContent = featuredCtaLabel(slot);
      actions.appendChild(button);
      footer.appendChild(actions);
      content.appendChild(footer);

      wrapper.appendChild(content);
      slot.appendChild(wrapper);
    }

    function render() {
      restoreHiddenCards();
      slots.forEach(function (slot) { slot.innerHTML = ""; });
      setPaginationHidden(false);

      var g = getGarage();
      var hasVehicle = Boolean(g.year && g.make && g.trim);
      var vehicleText = hasVehicle ? (g.year + " " + g.make + " " + g.trim) : "";

      slots.forEach(function (slot) {
        setFinderVisibility(slot, !hasVehicle);
      });

      if (!hasVehicle) {
        slots.forEach(function (slot) {
          setHubMessage(
            slot,
            slotMessage(slot, "data-ccw-no-selection-message", "Enter your vehicle to see a recommended bundle.")
          );
        });
        return;
      }

      var featuredHandle = normalizeHandle(g.featuredBundleHandle);
      if (!featuredHandle) {
        slots.forEach(function (slot) {
          setHubMessage(
            slot,
            slotMessage(slot, "data-ccw-no-selection-message", "Enter your vehicle to see a recommended bundle.")
          );
        });
        return;
      }

      var selectedMatch =
        findMatch(g.year, g.make, g.trim) ||
        findEntryByMapHandle(g.mapHandle) ||
        findEntryByRouteProductHandle(featuredHandle);

      var featuredResult = findCardByHandle(featuredHandle);
      if (!featuredResult || !featuredResult.cardEl) {
        slots.forEach(function (slot) {
          setHubMessage(
            slot,
            slotMessage(
              slot,
              "data-ccw-missing-featured-message",
              "We found your bundle, but it isn't currently in this collection."
            )
          );
        });
        return;
      }

      var featuredMeta = readCardMeta(featuredResult.cardEl);
      if (!featuredMeta || !featuredMeta.url) {
        slots.forEach(function (slot) {
          setHubMessage(
            slot,
            slotMessage(
              slot,
              "data-ccw-missing-featured-message",
              "We found your bundle, but it isn't currently in this collection."
            )
          );
        });
        return;
      }

      slots.forEach(function (slot) {
        setHubMessage(slot, "");
        appendMatchBanner(slot, vehicleText, featuredMeta);
        appendFeaturedCard(slot, featuredMeta, vehicleText, selectedMatch);
      });

      // Keep featured bundle visible in the grid and only hide non-featured bundle cards.
      var hiddenBundleCount = 0;
      var bundleCards = document.querySelectorAll("[data-ccw-is-bundle='true']");
      bundleCards.forEach(function (card) {
        if (isInsideAnySlot(card)) return;
        if (getHandleFromNode(card) === featuredHandle) return;
        hideCard(card, "data-ccw-bundle-hidden");
        hiddenBundleCount += 1;
      });

      if (hiddenBundleCount > 0 && hidePaginationWhenFiltered(slots[0])) {
        setPaginationHidden(true);
      }
    }

    render();
    window.addEventListener("ccw:garage_changed", render);
    RERENDER_HOOKS.push(render);
  }

  // The collection grid (filters/sort) swaps the whole .facest-filters-section,
  // sidebar finder included, so re-mount what lives inside it.
  var RERENDER_HOOKS = [];
  function remountAfterCollectionRender() {
    mountFinders();
    RERENDER_HOOKS.forEach(function (fn) {
      try { fn(); } catch (e) {}
    });
  }

  function mountAll() {
    mountFinders();
    mountLabels();
    mountFitmentMessages();
    mountSelectVehicleHashTrigger();
    mountHubFeaturedBundles();
  }

  // Public API 
  window.CCWGarage = window.CCWGarage || {};
  window.CCWGarage.get = getGarage;
  window.CCWGarage.set = setGarage;
  window.CCWGarage.clear = clearGarage;
  window.CCWGarage.mount = mountAll;
  window.CCWGarage.findMatch = findMatch;

  // Auto-mount
  document.addEventListener("DOMContentLoaded", mountAll);
  document.addEventListener("collection:rerendered", remountAfterCollectionRender);
})();
